import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '@/store/authStore';
import { clubsBookingApi } from '@/api/clubs-booking';
import { getClubSiteUrl } from '@/utils/publicSite';

const SubdomainAdminEntryPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = auth.getUser();
    if (!user.isAuthenticated) {
      navigate('/login', { replace: true });
      return;
    }

    if (user.role === 'parent') {
      navigate('/my-bookings', { replace: true });
      return;
    }

    const routeAdminToOwnDomain = async () => {
      try {
        const profile = await clubsBookingApi.getMyClubProfile();
        const ownSlug = profile?.publicSlug?.trim().toLowerCase();
        if (ownSlug) {
          const ownSiteUrl = getClubSiteUrl(ownSlug);
          const ownSiteOrigin = ownSiteUrl ? new URL(ownSiteUrl).origin : '';
          if (ownSiteOrigin && ownSiteOrigin !== window.location.origin) {
            window.location.assign(`${ownSiteOrigin}/dashboard`);
            return;
          }
        }
      } catch {
        // If profile lookup fails, continue to dashboard on current domain.
      }

      navigate('/dashboard', { replace: true });
    };

    void routeAdminToOwnDomain();
  }, [navigate]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#f3f4f8] p-6">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-5 h-10 w-10 animate-spin rounded-full border-4 border-emerald-200 border-t-emerald-600" />
        <h1 className="text-xl font-semibold text-slate-900">Opening admin dashboard</h1>
        <p className="mt-2 text-sm text-slate-600">
          We&apos;re checking your account and taking you to the right workspace.
        </p>
      </div>
    </main>
  );
};

export default SubdomainAdminEntryPage;
